import { render } from "./SimpleNotesKpiCard.vue?vue&type=template&id=31b1eb96&scoped=true"
import script from "./SimpleNotesKpiCard.vue?vue&type=script&lang=js"
export * from "./SimpleNotesKpiCard.vue?vue&type=script&lang=js"

import "./SimpleNotesKpiCard.vue?vue&type=style&index=0&id=31b1eb96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b1eb96"]])

export default __exports__